import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';
import '../assets/css/partnerProClub.scss';
import '../assets/css/partnerPortal/welcome.scss';
import '../assets/css/partnerPortal/homepage.scss';
import '../assets/css/partnerPortal/salesEnablement.scss';

import checkmark from '../assets/img/partnerPortal/EnablementSales/checkmark-green.svg';




function BadgeSection(props) {

    const [badge] = useState(props.badge);
    const [title] = useState(props.title);
    const [eyeBrow] = useState(props.eyeBrow);
    const [time] = useState(props.time);
    const [buttonLink] = useState(props.buttonLink);
    const [covers] = useState(props.covers);
    const [target] = useState(props.target);


    return (

        <>
        <div className="d-flex flex-column align-items-start width48 cardBoxBadges p-4 mr-3 screenChange">
            <div className="d-flex flex-column align-items-center align-self-stretch">
                <img src={badge} />
            </div>
            <div className="d-flex flex-column align-items-center align-self-stretch pb-3 pt-3">
                <div className="d-flex flex-column align-items-start align-self-stretch ">
                    <div className="d-flex align-items-start align-self-stretch">
                        <div className="eyebrowTextUpperCase">{eyeBrow}</div>
                    </div>
                    <div className="d-flex pt-2 pb-2 flex-column align-items-center align-self-stretch ">
                        <div className="d-flex flex-column align-items-start align-self-stretch justify-content-center ">
                            <div className="titleSales">{title}</div>
                            <div className="subTitleSales">{time} hours</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex flex-column align-items-start align-self-stretch mb-4">
                <div className="eyebrowTextUpperCase">Covers:</div>
                <div className="d-flex flex-column align-items-start align-self-stretch">
                    {covers.map(p => <div className="d-flex align-items-start align-self-stretch">
                            <img src={checkmark} />
                            <div className="d-flex align-items-start pt-2">
                                <div className="salesTopicsText">{p}</div>
                            </div>
                        </div>)}
                </div>
            </div>

            <div className="d-flex align-items-center align-self-stretch">
                <a href={buttonLink} target={target || "_blank"} className="w-100 d-flex justify-content-center"  >
                    <div className="d-flex align-items-center justify-content-center width97 borderButtonOne">
                        <div className="buttonTitleLetters">Start Training</div>
                    </div>
                </a>
            </div>
        </div>
        </>

    )


}

export default withRouter(BadgeSection);



